import React from 'react';
import CampaignGroup from '../../areas/campaign/components/campaign-group';
import {
  RelatedArticleContainer,
  RelatedArticleWrapper,
  StyledArticle,
  StyledFeaturedArticle,
} from './styles';
import type { FeaturedArticleProps } from './types';
import { Article } from '../article/article';
import { RelatedArticle } from './related-article';
import type { Article as ArticleType } from 'src/types';

export const FeaturedArticle: React.FC<FeaturedArticleProps> = ({
  article,
  embedded = true,
  related = [],
}) => {
  const articleId = article ? article.id : null;
  const relatedArticles: ArticleType[] = (
    article && article.related && article.related.articles
      ? related.concat(article.related.articles)
      : related
  )
    .filter(Boolean)
    .filter(item => item?.id !== articleId)
    .sort(
      (a, b) =>
        new Date(b?.publishedAt || '1971-1-1').getTime() -
        new Date(a?.publishedAt || '1971-1-1').getTime()
    ) as ArticleType[];

  return (
    <StyledFeaturedArticle>
      {!!article && (
        <StyledArticle>
          <Article {...article} embedded={embedded} />
        </StyledArticle>
      )}
      <RelatedArticleContainer fullWidth={!article}>
        <RelatedArticleWrapper>
          {relatedArticles.map(item => (
            <RelatedArticle key={item.id} article={item} />
          ))}
        </RelatedArticleWrapper>
        {article && article.related && article.related.campaign && (
          <CampaignGroup campaigns={[article.related.campaign as any]} />
        )}
      </RelatedArticleContainer>
    </StyledFeaturedArticle>
  );
};
